import React from 'react';
import SignUpForm from './SignUpForm';
import Logo from '../../util/Logo';
import makeStyles from '@mui/styles/makeStyles';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  logo: {
    marginTop: '-50px',
    padding: theme.spacing(0, 4, 4),
  },
}));

const Signup = ({token, verificationToken}) => {
  const classes = useStyles();

  return (
    <Container className={classes.root} component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.logo}>
        <Logo />
      </div>
      <SignUpForm token={token} verificationToken={verificationToken}/>
    </Container>
  );
};

export default Signup;
